import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=b512a762&scoped=true&"
import script from "./addView.vue?vue&type=script&lang=js&"
export * from "./addView.vue?vue&type=script&lang=js&"
import style0 from "./addView.vue?vue&type=style&index=0&id=b512a762&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b512a762",
  null
  
)

export default component.exports